/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { Document } from "@common/model/_adocument";
import { User } from "@common/model/user";


// define & export class
export class TeamVaultService {
    GetUserDocument;
    GetUserDocuments;
    GetDocumentUsers;
    loadDocuments;
    shareHandler: Function;
    getUsersEligibleForShare;
    getSubjectFamily;
    populateSubject;
    loadDiscussions;
    getComments;
    checkDocument;
    getDocumentUsers;
    checkFile;
    createStatus;
    addDocument;
    addDocumentWithContent;
    createDocumentMetadata;
    OpenShareServiceModal;

    static $inject = ["$window", "CommonService", "PopUpService", "$rootScope", "CacheService", "base64", "ApiAdapterService", "$q", "$http", "$uibModal", "isNode"];

    constructor(
        $window,
        CommonService,
        PopUpService,
        $rootScope,
        CacheService,
        base64,
        ApiAdapterService,
        $q,
        private $http: ng.IHttpService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        isNode
    ) {

        this.checkDocument = (doc, multiple?) => {

            var acceptedTypes = ['txt', 'doc', 'docx', 'pptx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'gif', 'bmp', 'pdf', 'txt', 'rtf', 'ppt', 'odt', 'ods', 'odp', 'zip', 'csv'];
            if (!!doc.filename && acceptedTypes.indexOf(CommonService.getExtension(doc.filename.toLowerCase())) == -1) {
                if (!multiple)
                    PopUpService.openInformationModal('The file you tried to upload is not a format currently supported by eCare Vault.');
                return false;
            } else {
                return true;
            }

        }

        this.checkFile = (file) => {
            if (!file.filename && file.name) {
                file.filename = file.name;
            }
            if (file.filename.length > 99) {
                var ext = CommonService.getExtension(file.filename.toLowerCase());
                file.filename = file.filename.substr(0, 100 - (ext.length + 1)) + '.' + ext;
            }

            if (file) {
                //prev file size was 8388608
                if ((file.size || file.size === 0) && file.size < 7340033) {
                    return true;
                }
            }
            return false;
        }

        this.getComments = (documentId, password = 'password', fetchSystemComments?) => {
            var deferred = $q.defer();
            var loadSystemMessage;
            if (!!fetchSystemComments) {
                loadSystemMessage = fetchSystemComments;
            }
            ApiAdapterService.getComments(documentId, password, loadSystemMessage).then(s => {
                deferred.resolve(s);
            }, e => {
                deferred.resolve(null);
            }
            );
            return deferred.promise;
        }


        this.shareHandler = (list, shareResponse) => {
            for (var i = 0; i < shareResponse.shared.length; i++) {
                var found = false;
                for (var j = 0; !!list && j < list.length; j++) {
                    if (shareResponse.shared[i].userId == list[j].userId) {
                        found = true;
                    }
                }
                if (found == false) {
                    list.push(shareResponse.shared[i]);
                }
            }


            for (var i = 0; i < shareResponse.revoked.length; i++) {
                var rFound = false;
                for (var j = 0; list && j < list.length; j++) {
                    if (shareResponse.shared[i].userId == list[j].userId) {
                        rFound = true;
                    }
                }
                if (rFound != false) {
                    list.splice(rFound, 1);
                }
            }
        }

        this.addDocument = (document, subject?, sharedUsersIds?, sharedPermissionTypes?, type?) => {

            var deferred = $q.defer();

            if (!!type) {
                document.documentType = type;
            }

            //if its a status / cf photo
            if (document.documentType == 'FOLIO' && (!!document.comment && document.comment.length > 0)) {

                var attachmentDoc = new Document();
                attachmentDoc.filename = document.filename;
                attachmentDoc.content = (document.content);
                attachmentDoc.documentType = 'DOCUMENT';
                var attachmentEncoded = JSON.stringify(attachmentDoc);

                document.attachmentContents = window.btoa(attachmentEncoded);

                document.contentType = 'status';
                document.filename = 'status.txt';
                document.content = window.btoa(document.comment);
                document.comment = '';
            }

            if (!!subject) {
                document.subjectId = subject.subjectId;
            }



            ApiAdapterService.createDocument(document, sharedUsersIds, sharedPermissionTypes, CacheService.getPassword()).then(
                (s) => {
                    s.subject = document.subject;
                    deferred.resolve(s);
                },
                (e) => {
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }


        this.addDocumentWithContent = (content, type, subject, sharedUsersIds?) => {

            var deferred = $q.defer();
            if (!subject) {
                deferred.reject('Subject not found');
            }
            var d = new Document();

            d.subjectId = subject.subjectId;
            //d.content = $window.btoa(content);
            d.content = base64.encode(content);
            d.documentType = type;
            d.filename = "status.txt";
            d.contentType = 'status';
            //d.comment = content;
            d.keywords = "status";
            ApiAdapterService.createDocument(d, sharedUsersIds, null, CacheService.getPassword()).then(
                (s) => {
                    deferred.resolve(s);
                },
                (e) => {
                    deferred.reject(e);
                }
            );
            return deferred.promise;
        }

        this.loadDocuments = (providerSubjectId?, type?) => {

            var deferred = $q.defer();
            try {

                var subjectId = null;
                if (!!CacheService.getCurrentSubject()) {
                    subjectId = CacheService.getCurrentSubject().subjectId;
                }

                var docType = '';
                type && (docType = type);

                ApiAdapterService.getDocuments( CacheService.getUser().userId , docType ,  subjectId).then(
                    (docs) => {

                        var filteredDocs = [];
                        for (var i = 0; i < docs.length; i++) {

                            if (!docs[i].owner && docs[i].ownerId == CacheService.getUser().id) {
                                ApiAdapterService.reportError({ 'unexpected': 'doc doesnt have owner object', 'doc': docs[i] });
                                docs[i].owner = new User().deserialize(JSON.parse(JSON.stringify(CacheService.getUser())));
                            }

                            filteredDocs.push(docs[i]);
                        }
                        deferred.resolve(filteredDocs.sort((n1, n2) => n2.activityDate - n1.activityDate));
                    },
                    (error) => {
                        deferred.resolve([]);
                        console.log(error, 'Error in getting docs');
                    }
                );
            } catch (e) {
                console.log(e, 'Error in getting docs');
                deferred.resolve([]);
            }
            return deferred.promise;
        }


        this.loadDiscussions = (providerSubjectId?, type?) => {

            var deferred = $q.defer();
            try {

                var subjectId = providerSubjectId || null;// CacheService.getCurrentSubject().subjectId;

                console.log(subjectId, CacheService);
                var docType = '';
                type && (docType = type);
                ApiAdapterService.getDiscussions(subjectId, CacheService.getUser().userId, CacheService.getPassword()).then(
                    (docs) => {
                        deferred.resolve(docs);
                    },
                    (error) => {
                        deferred.resolve([]);
                        console.log(error, 'Error in getting docs');
                    }
                );
            } catch (e) {
                console.log(e, 'Error in getting docs');
                deferred.resolve([]);
            }
            return deferred.promise;
        }


        this.getUsersEligibleForShare = (subjectId, documentId, subjectIdList?, postType?) => {

            var all = [];
            var deferred = $q.defer();

            if (!subjectIdList || subjectIdList == "") {
                ApiAdapterService.getTeamMembers(subjectId, documentId, postType).then(s => {
                    deferred.resolve(s);
                }, (e) => {
                    PopUpService.openInformationModal(e);
                    deferred.reject(e);
                });
            } else {
                ApiAdapterService.getProviders(CacheService.getUser().id, subjectIdList).then(
                    (s) => {
                        var teamMemberList = s;
                        deferred.resolve(teamMemberList);
                    }, (e) => {
                        deferred.resolve([]);
                    });
            }

            return deferred.promise;
        }


        this.getDocumentUsers = (id) => {
            var deferred = $q.defer();
            try {
                ApiAdapterService.getDocumentUsers(id).then((s) => {
                    deferred.resolve(s);
                }, (e) => {
                    console.log(e, 'Error in getting document Users');
                    deferred.resolve([]);
                })

            } catch (e) {
                console.log(e, 'Error in getting document Users');
                deferred.resolve([]);
            }
            return deferred.promise;
        }

        this.createDocumentMetadata = (document, folderId, subject?, sharedUsersIds?, userpermissionTypes?, type?) => {
            var deferred = $q.defer();
            if (!!type) {
                document.documentType = type;
            }
            if (!!subject) {
                document.subjectId = subject.subjectId;
            }
            document['allowEmptyContent'] = true;
            if (!document.subject) {  //For Resource folder
                ApiAdapterService.createRSDocumentMetadata(document, folderId).then(
                    (s: any) => {
                        deferred.resolve(s);
                    },
                    (e: any) => {
                        deferred.reject(e);
                    }
                );
            } else {
                ApiAdapterService.createDocumentMetadata(document, folderId, sharedUsersIds, userpermissionTypes, CacheService.getPassword()).then(
                    (s: any) => {
                        s.subject = document.subject;
                        deferred.resolve(s);
                    },
                    (e: any) => {
                        deferred.reject(e);
                    }
                );
            }

            return deferred.promise;
        }
    }
}
angular.module('eCareVault.common.services')
    .service('TeamVaultService', TeamVaultService);

